import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';

const REPORT_FILE_NAME_LABELS = {
  conversation: '会话报表',
  agent: '客服报表',
  label: '标签报表',
  inbox: '收件箱报表',
  team: '团队报表',
  csat: '满意度报表',
  sla: 'SLA报表',
};

const getSelectedLocale = () =>
  window?.chatwootConfig?.selectedLocale ||
  document?.documentElement?.lang ||
  (typeof navigator !== 'undefined' ? navigator.language : 'en');

const isChineseLocale = () =>
  getSelectedLocale()?.toLowerCase().replace(/_/g, '-').startsWith('zh');

export const sanitizeFileNamePart = value =>
  value.replace(/[\\/:*?"<>|]/g, '_').trim();

export const getFileTimestamp = () => Math.floor(Date.now() / 1000);

export const downloadCsvFile = (fileName, content) => {
  const contentType = 'data:text/csv;charset=utf-8;';
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  link.click();
  return link;
};

export const generateFileName = ({ type, to, businessHours = false }) => {
  if (isChineseLocale()) {
    let name = `${REPORT_FILE_NAME_LABELS[type] || sanitizeFileNamePart(type)}_${format(
      fromUnixTime(to),
      'yyyy-MM-dd'
    )}`;
    if (businessHours) {
      name = `${name}_工作时间`;
    }
    return `${name}_${getFileTimestamp()}.csv`;
  }

  let name = `${type}-report-${format(fromUnixTime(to), 'dd-MM-yyyy')}`;
  if (businessHours) {
    name = `${name}-business-hours`;
  }
  return `${name}-${getFileTimestamp()}.csv`;
};
